import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromDeviceReset from './reducers/device-reset.reducer';
import { EffectsModule } from '@ngrx/effects';
import { DeviceResetEffects } from './effects/device-reset.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('deviceReset', fromDeviceReset.reducer),
    StoreModule.forFeature('deviceResetlog', fromDeviceReset.deviceResetLogreducer),
    EffectsModule.forFeature([DeviceResetEffects])
  ]
})
export class DeviceResetModule { }
